import DOMPurify from 'dompurify';

/**
 * Strips scripts, event handlers and javascript: URLs from stored
 * rich text (Quill, imported research, meeting notes) before it is
 * rendered with dangerouslySetInnerHTML.
 */
export default function sanitizeHtml(html?: string | null): string {
  // Keep target so Quill's target="_blank" links still open in a new tab.
  return DOMPurify.sanitize(html || '', { ADD_ATTR: ['target'] });
}
